import {parseCookies} from 'nookies';
import {useCallback, useEffect, useState} from 'react';
import {
  useDeleteFollowCompany,
  useUpdateFollowCompany,
} from '../repositories/companiesRepository';

type Props = {
  companyId: number;
  followCount: number;
  followed: boolean;
};

export function useHandleFollowCompany({
  companyId,
  followCount,
  followed,
}: Props) {
  const cookies = parseCookies();
  const [followCountUpdated, setFollowCountUpdated] =
    useState<number>(followCount);
  const [isFollowed, setIsClipped] = useState<boolean>(followed);

  const updateFollowCompany = useUpdateFollowCompany({
    onSuccessFunc({followCompanyCount}) {
      setIsClipped(true);
      setFollowCountUpdated(followCompanyCount);
    },
  });
  const deleteFollowCompany = useDeleteFollowCompany({
    onSuccessFunc({followCompanyCount}) {
      setIsClipped(false);
      setFollowCountUpdated(followCompanyCount);
    },
  });

  useEffect(() => {
    setFollowCountUpdated(followCount);
    setIsClipped(isFollowed);
  }, [companyId]);

  const unFollowCompanyUsecase = useCallback(
    async function unFollowCompanyUsecase() {
      deleteFollowCompany.mutate({companyId});
    },
    [companyId, cookies],
  );

  const updateFollowCompanyUsecase = useCallback(
    async function updateFollowCompanyUsecase() {
      updateFollowCompany.mutate({companyId});
    },
    [companyId, cookies],
  );

  const handleFollowCompany = useCallback(async () => {
    if (isFollowed) {
      await unFollowCompanyUsecase();
      return;
    }

    await updateFollowCompanyUsecase();
  }, [unFollowCompanyUsecase, isFollowed, updateFollowCompanyUsecase]);

  return {
    handleFollowCompany,
    followCountUpdated,
    isFollowed,
    updateFollowCompanyUsecase,
  };
}
